import { useEffect } from "react";

import { useHeaderTabsContext } from "services/common/HeaderTabsProvider";

function usePageTitleUpdater() {
  const headerTabsContext = useHeaderTabsContext();

  useEffect(() => {
    function updatePageTitleFromLocation() {
      document.title = `Parkki - ${headerTabsContext.headerTitle ?? "Login"}`;
    }
    updatePageTitleFromLocation();
  }, [headerTabsContext.headerTitle]);
}

export default usePageTitleUpdater;
